import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import 'quill-mention';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { client_domain } from "@/main.js";

export default {
  components: {
    Multiselect,
  },
  data() {
    return ({
      token_exists: false,
      user_details: {
        "user_role": '',
        "user_id": '',
      },
      temporaryPost: null,
      temporary_hub_post: null,
      isSubmitting: false,
      isDropdownVisible: false,
      fileName: '',
      imagePreview: null,
      topics: [],
      created_by_id: this.created_by,
      portals: [],
      isMaster: false,
      selectedPortals: [],
      selectedMasterPortal: '',
      categories: [],
      selectedPortalId: null,
      selectedTopicId: null,
      selectedVisibility: 'public',
      searchQuery: "",
      errors: {
        voice_description: null,
        voice_name: null,
        audio_file: null,
        portal: null,
        segment: null,
        report_description: null
      },
      users: [],
      selectedUserIds: [],
      portal_users: [],
      cbo_domain: false,

      isRecording: false,
      audio_file: null,
      mediaRecorder: null,
      recordedChunks: [],
      audio_file_name: '',
      upload_media: null,
      fileError: '',
      audioError: '',
      comments_off: true,
      showSuggestions: false,
      currentTagPosition: -1,
      portal_types: [],
      selectedPortalType: null,
      contactEmail: '',
      payload: {},
      latitude: null,
      longitude: null,
      report_title: null,
      location: null,
      incident_description: null,

      document_name: '',
      document_description: '',
      selected_reviewers: [],
      tempSelectedReviewer: [],
      reviewers: [],
      event_types: [],
      event_type: '',
    });
  },
  props: {
    group_id: {
      type: String,
      required: false,
      default: null
    },
    created_by: {
      type: String,
      required: false,
      default: null
    },
    is_public: {
      type: Boolean,
      default: false,
    },
    portalId: {
      type: [Number, String],
      required: false
    },
    active_tab: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();

    this.$nextTick(() => {
      this.initQuillEditor();
    });
    if (this.$route.name === 'view_portal') {
      this.selectedPortalId = this.$route.params.portal_id
    }
    if (this.$route.name === 'view_incidents') {
      this.selectedPortalId = this.portalId;
      this.payload = {
        filter_values: {
          portal_type__name: 'incident',
          portal_id: this.portalId

        }
      }
    }
    else {
      this.payload = {}
    }

    if (client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }
    const feedModal = $('#feed_modal');
    const voiceModal = $('#voice_modal');
    const createCommunityAssetModal = $('#create_community_asset_modal');
    const groupFeedModal = $('#group_feed_modal');

    feedModal.on('show.bs.modal', () => {
      this.resetPortalSelection();
    });

    voiceModal.on('show.bs.modal', () => {
      this.resetPortalSelection();
    });

    createCommunityAssetModal.on('show.bs.modal', () => {
      this.resetPortalSelection();
    });


    groupFeedModal.on('show.bs.modal', () => {
      this.resetPortalSelection();
    });
  },

  computed: {
    portal_id() {
      return this.$route.params.portal_id;
    },
    isPublic() {
      return this.selectedVisibility === 'public';
    },
    isHomePage() {
      return this.$route.name === 'home'; // Assuming your home page route is named 'home'
    },
    isPortalPage() {
      return this.$route.name === 'home_filter';
    },
    isViewPortalPage() {
      return this.$route.name === 'view_portal';
    },
    isGroupPage() {
      return this.$route.name === 'view_group';
    },
    isIncidentPage() {
      return this.$route.name === 'view_incidents'
    },
    isEventsPage() {
      return this.$route.name === 'view_events'
    },
    isCommunityAssetPage() {
      return this.$route.name === 'community_asset'
    },
    filteredUsers() {
      if (!this.searchQuery) {
        return this.users;
      }
      const query = this.searchQuery.toLowerCase();
      return this.users.filter(user =>
        user.first_name.toLowerCase().includes(query) ||
        user.last_name.toLowerCase().includes(query)
      );
    },
    areAllSelected() {
      const filteredIds = this.filteredUsers.map(user => user.id);
      return filteredIds.every(id => this.selectedUserIds.includes(id)) && filteredIds.length > 0;
    },
    filteredPortals() {
      if (!this.searchQuery) {
        return this.portals.filter(portal =>
          !portal.portal_type || portal.portal_type.name !== 'incident'
        );
      }
      const query = this.searchQuery.toLowerCase();
      return this.portals.filter(portal =>
        (!portal.portal_type || portal.portal_type.name !== 'incident') &&
        portal.name.toLowerCase().includes(query)
      );
    },
    areAllSubPortalsSelected() {
      const filteredIds = (this.filteredPortals || []).map(portal => portal.id);
      return filteredIds.length > 0 && filteredIds.every(id => this.selectedPortals.includes(id));
    },
  },

  methods: {
    resetPortalSelection() {
      this.selectedPortalId = '';
      this.selectedTopicId = '';
      this.errors.portal = '';
      this.errors.segment = '';
      this.errors.name = '';
      this.fileName = '';
      // this.errors.report_name = '';
      this.audio_file_name = '';
      this.fileError = '';
      this.report_description = '';
    },
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    handleCustomer() {
      const role = this.user_details.user_role
      if (role === 'user') {
        return false
      }
      else {
        return true
      }
    },
    handleApprovalFileUpload(event) {
      const file = event.target.files[0];

      if (file) {
        if (file.type.startsWith("audio/")) {
          this.fileError = "Audio files are not allowed.";
          this.upload_media = null;
          this.fileName = "";
          this.imagePreview = null; // Reset preview if an invalid file is selected
          event.target.value = ""; // Clear file input
        } else {
          this.fileName = file.name;
          this.fileError = "";
          this.upload_media = file;

          // Check if the file is an image before previewing
          if (file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = (e) => {
              this.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
          } else {
            this.imagePreview = null; // Reset preview for non-image files
          }
        }
      } else {
        this.fileName = "";
        this.fileError = "";
        this.upload_media = null;
        this.imagePreview = null;
      }
    },
    getToken() {
      return get_token();
    },



    fetch_topics(portal_id) {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_topics_api`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: { portal_id: portal_id },
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.topics = response.topics
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    validationFeedForm() {
      this.errors = {};
      let valid = true;

      if (this.$route.name !== 'view_portal' && !this.selectedPortalId) {
        this.errors.portal = "You must tag a portal.";
        valid = false;
      }

      if (!this.selectedTopicId) {
        this.errors.segment = "You must tag a segment.";
      }
      return valid;
    },

    create_group_feed() {
      const formData = new FormData();
      formData.append('feed_name', this.group_report_name);
      this.feed_report_description = this.$refs.quillFeedReportEditorRef.getHTML()
      formData.append('description', this.feed_report_description);
      formData.append('group_id', this.group_id)
      formData.append('can_comment', this.comments_off);
      if (this.upload_media) {
        formData.append('file', this.upload_media);
      }
      if (!this.group_report_name) {
        this.errors.report_name = 'Feed name is required';
        return;
      }
      if (this.audio_file) {
        formData.append('file', this.audio_file, this.audio_file_name);
      }
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_group_feed/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        beforeSend: function () {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading()
            }
          });
        },
        success: (response) => {
          Swal.close();
          const status = response.status;
          this.$emit('new_feed', response.feed_data)


          if (status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Feed Created',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {

              $('#group_feed_modal').modal('hide');
              this.group_report_name = '';
              this.isDropdownVisible = false;
            });

          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON;
          if (response_data.status === "error") {
            this.errors.report_name = response_data.message
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }
      })
    },


    validationPortalForm() {
      this.errors = {};
      let valid = true;

      if (!this.portal_name) {
        this.errors.portal_name = 'Portal name is required';
        valid = false;
      }

      return valid;
    },


    validationGroupForm() {
      this.errors = {};
      let valid = true;

      if (!this.group_name) {
        this.errors.group_name = 'Group name is required';
        valid = false;
      }

      return valid;
    },
    createGroup() {
      if (!this.validationGroupForm()) {
        return;
      }

      this.isSubmitting = true;

      const formData = new FormData();
      formData.append('name', this.group_name);
      this.description = this.$refs.quillGroupEditorRef.getHTML()
      formData.append('description', this.description);
      formData.append('is_public', this.isPublic);

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/create_group/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          this.$emit('addGroup', response.group)
          $('#group_modal').modal('hide')
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON;

          if (response_data.status === "error") {

            this.errors.group_name = response_data.message
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    validationCommunityForm() {
      this.errors = {};
      let valid = true;

      if (!this.asset_name) {
        this.errors.asset_name = 'Asset name is required';
        valid = false;
      }

      if (!this.location) {
        this.errors.location = 'Location is required';
        valid = false;
      }

      if (!this.category_id) {
        this.errors.category_id = 'Category selection is required';
        valid = false;
      }
      return valid;
    },
    createcommunity_asset() {
      if (!this.validationCommunityForm()) {
        return;
      }
      $('#create_community_asset_modal').modal('hide');

      this.isSubmitting = true;
      const formData = new FormData();
      formData.append('name', this.asset_name);
      this.description = this.$refs.quillAssetEditorRef.getHTML()
      formData.append('description', this.description);
      formData.append('location', this.location);
      formData.append('category_id', this.category_id);
      formData.append('subscription_fee', this.subscription_fee);
      if (this.upload_media) {
        formData.append('file', this.upload_media);
      }

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_community_asset/`,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: formData,
        processData: false,
        contentType: false,

        success: (response) => {
          this.$emit('newAsset', response.community_asset_data
          )
          const status = response.status;
          if (status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Community asset Created Successfully',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#create_community_asset_modal').modal('hide');
              this.isDropdownVisible = false;
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON;
          if (response_data.status === "error") {
            this.errors.asset_name = response_data.message

          }
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    get_community_assets_category() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_community_assets_category/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          this.categories = response.data.categories;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    add_group_member() {
      if (this.selectedUserIds.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Warning',
          text: 'Please select at least one user.',
          showConfirmButton: true
        });
        return;
      }
      const data = {
        group_id: this.group_id,
        user_id: this.selectedUserIds
      }
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/add_group_member/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(data),
        success: (response) => {
          const status = response.status;
          if (status === "success") {

            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Group member(s) added',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              window.location.reload();
            });
          }
        },
        error: () => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: "User already Exist",
            showConfirmButton: false,
            timer: 2000,
            position: 'bottom-end',
            toast: true
          })

        }
      });
    },

    initQuillEditor() {
      if (!this.$refs.quillRef) {
        console.warn('Quill container not ready yet');
        return;
      }

      this.quill = new Quill(this.$refs.quillRef, {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['link', 'video', 'image'],
            ['clean']
          ],
          mention: {
            allowedChars: /^[A-Za-z0-9_]+$/,
            mentionDenotationChars: ['@'],
            source: (searchTerm, renderList) => {
              const matches = this.users
                .filter(user => {
                  const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
                  return fullName.includes(searchTerm.toLowerCase());
                })
                .map(user => ({
                  id: user.id,
                  value: `${user.first_name} ${user.last_name}`
                }));
              renderList(matches);
            },
            renderItem(item) {
              return `${item.value}`;
            }
          }
        },
        placeholder: 'Type your text here...',
      });

      this.$refs.quillReportEditorRef.quill = quill;

      quill.on('text-change', () => {
        const text = quill.root.innerText;
        const lastAtSymbol = text.lastIndexOf('@');

        if (lastAtSymbol !== -1) {
          this.currentTagPosition = lastAtSymbol;
          this.showSuggestions = true;
        } else {
          this.showSuggestions = false;
        }
      });

      quill.on('mention-selected', (user) => {
        this.selectUser(user);
      });
    },

    filterUsers(query) {
      if (!query) {
        this.filteredUsers = this.users;
        return;
      }
      this.filteredUsers = this.users.filter(user => {
        const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
        return fullName.includes(query.toLowerCase());
      });
    },

    selectUser(user) {
      const quill = this.$refs.quillReportEditorRef.quill;
      const beforeTag = this.description ? this.description.slice(0, this.currentTagPosition) : '';
      this.description = `${beforeTag}@${user.first_name}_${user.last_name} `;

      quill.root.textContent = `${beforeTag}@${user.first_name}_${user.last_name}`;
      this.$nextTick(() => {
        this.showSuggestions = false;
      });
    },

    clearErrors() {
      this.errors.incident_title = '';
      this.errors.incident_description = '';
      this.errors.location = '';
    },

    createIncidentReport() {
      this.clearErrors()

      const mapInput = document.getElementById('mapSearchBox');
      const baseUrl = `${window.location.origin}/view_incident_reports?incident_report_id=`;
      if (mapInput) {
        this.location = mapInput.value;
      }
      const formData = new FormData();
      formData.append('report_title', this.report_title);

      const rawDescription = this.$refs.quillReportEditorRef.getHTML();
      const plainDescription = rawDescription.replace(/<\/?[^>]+(>|$)/g, '');
      this.incident_description = plainDescription.trim();

      formData.append('description', this.incident_description);
      formData.append('portal_id', this.portalId);
      formData.append('location', this.location);
      formData.append('base_url', baseUrl)
      if (this.upload_media) {
        formData.append('files', this.upload_media);
      }

      if (!this.report_title) {
        this.errors.incident_title = 'Incident title is required';
        return;
      }

      if (!this.incident_description || this.incident_description.trim() === '<p><br></p>') {
        this.errors.incident_description = 'Incident description is required.';
        return;
      }
      if (!this.location || this.location.trim() === '') {
        this.errors.location = 'Incident location is required.';
        return;
      }

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/report_incident_management/create_incident_report/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        beforeSend: function () {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading()
            }
          });
        },
        success: (response) => {

          Swal.close();
          const status = response.status;

          if (status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Incident Report Created',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              this.resetForm();
              $('#incidentReportModal').modal('hide');
              this.$emit('newIncidentReport', response.report_data)
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON;
          if (response_data.status === "error") {
            this.errors.incident_title = response_data.message;
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },

    resetForm() {
      // Text fields
      this.report_title = '';
      this.incident_description = '';
      this.location = '';
      this.upload_media = null;

      // Quill editor
      if (this.$refs.quillReportEditorRef) {
        const quill = this.$refs.quillReportEditorRef.getQuill();
        if (quill) quill.setContents([{ insert: '' }]);
      }

      // File inputs
      this.fileName = '';
      this.uploaded_files = [];
      this.$nextTick(() => {
        const fileInput = document.getElementById("fileInput");
        if (fileInput) fileInput.value = "";
      });

      // Other selections
      this.selected_reviewers = [];
      this.selectedMasterPortal = '';
      this.selectedPortals = [];

      // Clear errors
      this.clearErrors();
    },

  },
};



